import { useState } from "react";
import { colors, fonts } from "../../constants/theme";

export default function ObjectiveCard({ icon, title, desc, alt, offset }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="obj-card-item"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: "#ffffff",
        border: `1.5px solid ${hovered ? "#22c55e" : "#def0d8"}`,
        borderRadius: 22,
        padding: "1.8rem 1.4rem 1.5rem",
        marginTop: offset ? "1.2rem" : 0,
        transform: hovered ? "translateY(-6px)" : "none",
        transition: "all .32s cubic-bezier(0.16, 1, 0.3, 1)",
        boxShadow: hovered
          ? "0 20px 45px rgba(34, 197, 94, 0.16), 0 0 0 1px rgba(34, 197, 94, 0.2)"
          : "0 10px 28px rgba(46, 125, 50, 0.06)",
        cursor: "pointer",
        overflow: "hidden",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
    >
      <div>
        <div
          style={{
            width: 52,
            height: 52,
            background: hovered ? "linear-gradient(135deg, #22b24c, #168d37)" : "linear-gradient(135deg, #eaf9e6, #d7f4ce)",
            border: `1px solid ${hovered ? "#22b24c" : "#c8ebb9"}`,
            borderRadius: 16,
            display: "grid",
            placeItems: "center",
            marginBottom: "1.2rem",
            boxShadow: hovered ? "0 8px 18px rgba(34, 180, 60, 0.25)" : "0 4px 12px rgba(46, 125, 50, 0.1)",
            transition: "all .3s ease",
            transform: hovered ? "scale(1.06)" : "none"
          }}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 24 24"
            fill="none"
            stroke={hovered ? "#ffffff" : "#168d37"}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ transition: "stroke .3s ease", filter: hovered ? "drop-shadow(0 2px 5px rgba(0,0,0,.18))" : "drop-shadow(0 2px 5px rgba(22,141,55,.12))" }}
            aria-hidden="true"
          >
            {icon === "accessibility" && <><path d="M3 10h18l-1.5-5h-15L3 10Z" /><path d="M5 10v9h14v-9M3 10a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0" /><path d="M9 19v-5h6v5" /></>}
            {icon === "personalization" && <><circle cx="12" cy="8" r="3" /><path d="M5.5 20a6.5 6.5 0 0 1 13 0M19 5v4m-2-2h4M4 6v4m-2-2h4" /></>}
            {icon === "education" && <><path d="M12 7v13M12 7C9.5 5.2 6.5 5 3 6v12c3.5-1 6.5-.8 9 1m0-12c2.5-1.8 5.5-2 9-1v12c-3.5-1-6.5-.8-9 1" /><path d="M6 9h3m-3 3h3m6-3h3m-3 3h3" /></>}
            {icon === "motivation" && <><path d="M8 4h8v4a4 4 0 0 1-8 0V4ZM8 6H5v2a4 4 0 0 0 4 4m7-6h3v2a4 4 0 0 1-4 4m-3 0v4m-4 4h8l-1-4H9l-1 4Z" /></>}
          </svg>
        </div>

        <h3
          style={{
            fontFamily: fonts.display,
            fontSize: "1.28rem",
            fontWeight: 800,
            color: "#072016",
            marginBottom: ".5rem",
            letterSpacing: "-0.02em"
          }}
        >
          {title}
        </h3>

        <p style={{ fontSize: ".92rem", color: "#556b5e", lineHeight: 1.62 }}>
          {desc}
        </p>
      </div>

      <div style={{ marginTop: "1.6rem", display: "flex", alignItems: "center", gap: "10px", borderTop: "1px solid #edf6ea", paddingTop: "12px" }}>
        <div style={{ flex: 1, height: 6, background: "#e2f2dd", borderRadius: 99, overflow: "hidden" }}>
          <div style={{ width: hovered ? "100%" : "75%", height: "100%", background: "linear-gradient(90deg, #22b24c, #48cf53)", borderRadius: 99, transition: "all 0.5s ease" }} />
        </div>
        <span style={{ fontSize: ".76rem", color: "#15803d", fontWeight: 800, whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "4px" }}>
          <span style={{ width: 5, height: 5, borderRadius: "50%", background: "#22b24c" }} />
          100% Impacto
        </span>
      </div>
    </div>
  );
}
